module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/blog your pathPrefix should be "blog"
  siteTitle: 'Jonas Bandi', // Navigation and Site Title
  siteTitleAlt: 'The personal website of Jonas Bandi', // Alternative Site title for SEO
  siteTitleShort: 'jonasbandi', // short_name for manifest
  siteUrl: 'https://jonasbandi.net', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: 'images/logo.png', // Used for SEO and manifest, path to your image you placed in the 'static' folder
  siteDescription: 'The personal website of Jonas Bandi.',
  minibio: `
    <strong>Jonas Bandi</strong> is an enthusiastic software professional, freelance developer, trainer and speaker.
  `,
  author: 'Jonas Bandi', // Author for schemaORGJSONLD
  organization: 'Jonas Bandi',

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@jbandi', // Twitter Username
  ogSiteName: 'Jonas Bandi', // Facebook Site Name
  ogLanguage: 'en_US',
  googleAnalyticsID: 'UA-62924965-1',

  // Manifest and Progress color
  themeColor: '#4147DC',
  backgroundColor: '#231C42',

  // Social component
  twitter: 'https://twitter.com/jbandi/',
  twitterHandle: '@jbandi',
  github: 'https://github.com/jbandi/',
  linkedin: 'https://www.linkedin.com/in/jonasbandi/',
}
